(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/play/iwg/game-launcher.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/play/iwg/game-launcher.js');
"use strict";

const {
  useEffect,
  useState
} = React;
const GameLauncher = () => {
  const {
    returnUrl,
    isEdge,
    iframeSrc,
    isSettledBet
  } = svs.eInstant.data.iwgGame;
  const {
    onMaximize,
    onMinimize,
    updateAccountBalance
  } = svs.eInstant.play.iwg.utils;
  const [fullScreen, setFullScreen] = useState(false);
  const onFullScreenChange = () => {
    const isInFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    if (isInFullscreen) {
      setFullScreen(true);
    } else {
      setFullScreen(false);
    }
  };
  useEffect(() => {
    addEventListener('fullscreenchange', onFullScreenChange);
    addEventListener('mozfullscreenchange', onFullScreenChange);
    addEventListener('webkitfullscreenchange', onFullScreenChange);
    return () => {
      removeEventListener('fullscreenchange', onFullScreenChange);
      removeEventListener('mozfullscreenchange', onFullScreenChange);
      removeEventListener('webkitfullscreenchange', onFullScreenChange);
    };
  }, []);
  useEffect(() => {
    const loggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    loggedIn && window.addEventListener('message', updateAccountBalance, false);
    return () => {
      loggedIn && window.removeEventListener('message', updateAccountBalance);
    };
  }, [updateAccountBalance]);
  const handleMinimize = e => {
    e === null || e === void 0 || e.preventDefault();
    onMinimize();
    setFullScreen(false);
  };
  const handleMaximize = e => {
    e === null || e === void 0 || e.preventDefault();
    onMaximize();
    setFullScreen(true);
  };
  return React.createElement("div", {
    className: "e-instant-fullscreen-wrap"
  }, React.createElement("div", {
    className: "e-instant-play-bar fc-white bg-fler-lotter row"
  }, React.createElement("div", {
    className: "left"
  }, React.createElement("a", {
    className: "e-instant-play-bar-link js-pause24-trigger",
    href: "",
    onClick: handleMinimize
  }, "Spelpaus24")), React.createElement("div", {
    className: "right"
  }, !isEdge && fullScreen ? React.createElement("a", {
    className: "e-instant-play-bar-link e-instant-play-bar-link-minimize js-e-instant-minimize",
    href: "",
    onClick: handleMinimize
  }, "Minimera", React.createElement("i", {
    className: "icon icon-300 icon-minimize padding-left-1"
  })) : React.createElement("a", {
    className: "e-instant-play-bar-link e-instant-play-bar-link-maximize js-e-instant-maximize",
    href: "",
    onClick: handleMaximize
  }, "Maximera", React.createElement("i", {
    className: "icon icon-300 icon-maximize padding-left-1"
  })), React.createElement("a", {
    className: "e-instant-play-bar-link e-instant-play-bar-link-close",
    href: returnUrl
  }, "St\xE4ng", React.createElement("i", {
    className: "icon icon-300 icon-close padding-left-1",
    title: "St\xE4ng"
  })))), React.createElement("iframe", {
    className: "e-instant-iframe ".concat(isSettledBet ? 'e-instant-iframe-settled' : ''),
    frameBorder: "0",
    loading: "eager",
    seamless: "seamless",
    src: iframeSrc
  }));
};
setGlobal('svs.eInstant.play.iwg.GameLauncher', GameLauncher);

 })(window);